<div class="min-h-screen flex items-center justify-center
    bg-[linear-gradient(to_right,transparent_30%,#ffffff_80%),url('images/front-pages/abstract_loomis.png')] 
    dark:bg-[linear-gradient(to_right,transparent_30%,#000000_80%),url('images/front-pages/abstract_loomis.png')] 
    bg-cover bg-center">

    <button type="button" class="light-dark-toggle absolute top-[20px] inline-block leading-none text-orange-400 transition-all md:top-[25px] ltr:right-[20px] rtl:left-[20px] ltr:md:right-[25px] rtl:md:left-[25px]" (click)="toggleTheme()">
        <i class="material-symbols-outlined !text-[20px] md:!text-[22px]">
            light_mode
        </i>
    </button>

    <div class="mx-auto max-w-screen-sm text-center">
        <h1 class="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-red-600 dark:text-red-500">
            {{ 'i18n.common.error_page.page_500.h1_0' | translate }}
        </h1>

        <p class="mb-4 text-3xl tracking-tight font-bold text-warning-600 md:text-4xl dark:text-white">
            {{ 'i18n.common.error_page.page_500.p_0' | translate }}
        </p>

        <p class="mb-4 text-lg font-light text-gray-100 dark:text-gray-400">
            {{ 'i18n.common.error_page.page_500.p_1' | translate }}
        </p>
    </div>

</div>







